<template>
    <b-button class="btn-table" :id="`remove-btn-${id}`" @click="$emit('click')">
        <DynamicIcon icon="trash" classString="icon-btn-table"/>
        <b-tooltip :target="`remove-btn-${id}`" triggers="hover" :title="titleTooltip" custom-class="tooltip-item-btn" noninteractive/>
    </b-button>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
    components: {
       DynamicIcon
    },
    props: {
        id: Number,
        titleTooltip: String
    }
}
</script>

<style scoped lang="scss">
</style>
